import React, { useState } from 'react';
import Sidebar from './Sidebar';
import GeneralSettings from './GeneralSettings';
import NavbarManagement from './NavbarManagement';
import FooterManagement from './FooterManagement';
import ColorScheme from './ColorScheme';

const AdminLayout = () => {
  const [activeSection, setActiveSection] = useState('general');
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  // Render content based on active section
  const renderContent = () => {
    switch (activeSection) {
      case 'general':
        return <GeneralSettings />;
      case 'navbar':
        return <NavbarManagement />;
      case 'footer':
        return <FooterManagement />;
      case 'colors':
        return <ColorScheme />;
      // Add more cases here for future sections
      default:
        return <GeneralSettings />;
    }
  };

  return (
    <div className="flex h-[calc(100vh-4rem)] bg-gradient-to-b from-[#0a0a1f] via-[#1a1a3e] to-[#0a0a1f]">
      {/* Sidebar - 30% on desktop, collapsible on mobile */}
      <div className="hidden lg:block lg:w-[30%] xl:w-[25%]">
        <Sidebar
          activeSection={activeSection}
          setActiveSection={setActiveSection}
          isMobileOpen={isMobileOpen}
          setIsMobileOpen={setIsMobileOpen}
        />
      </div>

      {/* Mobile Sidebar */}
      <div className="lg:hidden">
        <Sidebar
          activeSection={activeSection}
          setActiveSection={setActiveSection}
          isMobileOpen={isMobileOpen}
          setIsMobileOpen={setIsMobileOpen}
        />
      </div>

      {/* Main Content - 70% on desktop, full width on mobile */}
      <main className="flex-1 overflow-y-auto">
        <div className="max-w-6xl mx-auto p-4 sm:p-6 lg:p-8">
          {renderContent()}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
